import { useEffect } from "react";
import Reveal from "../components/Reveal";
import PageHeader from "../components/PageHeader";
import CTABand from "../components/CTABand";
import { SERVICES } from "../data/content";
import { setJsonLd, SEO_BASE } from "../lib/seo";

const Services = () => {
  useEffect(() => {
    setJsonLd("services-jsonld", {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Services — Vaskion Technologies Private Limited",
      itemListElement: SERVICES.map((s, i) => ({
        "@type": "ListItem",
        position: i + 1,
        item: {
          "@type": "Service",
          name: s.title,
          description: s.description,
          url: `${SEO_BASE}/services`,
          provider: { "@type": "Organization", name: "Vaskion Technologies Private Limited" },
        },
      })),
    });
    return () => setJsonLd("services-jsonld", null);
  }, []);

  return (
  <main data-testid="services-page">
    <PageHeader
      eyebrow="What We Do"
      title="Services"
      description="Full-lifecycle software engineering services — from consulting and custom development to AI, cloud and long-term support."
    />
    <section className="bg-white py-20 lg:py-24">
      <div className="container-site grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={(i % 3) * 80}>
            <article
              className="flex h-full flex-col border border-border bg-white p-8 shadow-sm transition-[transform,border-color] duration-200 hover:-translate-y-1 hover:border-brand-red"
              data-testid={`service-card-${i}`}
            >
              <service.icon className="h-8 w-8 text-brand-red" strokeWidth={1.5} aria-hidden="true" />
              <h2 className="mt-6 text-lg font-semibold leading-snug">{service.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-brand-grey">{service.description}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
    <CTABand />
  </main>
  );
};

export default Services;
